import { Fragment } from "react";

function RejecteddAccountStatusMessage() {
  return (
    <Fragment>
      <div>
        <h2>We’re Sorry, but There’s an Issue with Your Account</h2>
        <br />
        <p>
          Unfortunately, we were unable to connect your account to Stripe at
          this time. This can happen for a variety of reasons, and we’re here to
          help you understand what went wrong and how you can fix it.
        </p>
      </div>
    </Fragment>
  );
}

export default RejecteddAccountStatusMessage;
